import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store";
import { isSignedInState } from "../../store/slices/user";
import {
  appRoutes
} from "../../constants/routes";

const ProtectedRoute = () => {
  const isSignedIn = useAppSelector(isSignedInState);
  const { pathname, search } = useLocation();

  return (
    isSignedIn
      ? <Outlet/>
      : (
        <Navigate
          to={appRoutes.login}
          state={{
            path: pathname === appRoutes.feedback ? `${pathname}${search}` : appRoutes.root
          }}
        />
      )
  );
};

export default ProtectedRoute;
